<template lang="html">
  <div class="examplex">
    <vs-select
      autocomplete
      v-model="currentLanguage"
      class="selectLanguages w-full"
    >
      <vs-select-item :key="index" :value="index" :text="item" v-for="(item,index) in languages" />
    </vs-select>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        computed: {
            currentLanguage: {
                get () {
                    return this.$store.getters.getCurrentLanguage
                },
                set (value) {
                    this.$store.commit('setCurrentLanguage', value)
                    location.reload();
                }
            },
            ...mapGetters({
                languages: 'getLanguages'
            })
        }
    }
</script>
